import { render } from "./AutoPassFormModal.vue?vue&type=template&id=650a603d"
import script from "./AutoPassFormModal.vue?vue&type=script&lang=js"
export * from "./AutoPassFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__